module.exports = __webpack_public_path__ + "img/logo-full.378bd97.png";